export default __webpack_public_path__ + "static/indy-thinking-44c39f8a66e0405c1156b5ca0c6a438c.svg";